import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const UserProfile = lazyLoader(
  () => import("Containers/Settings/UserProfile/UserProfile")
);

export const SettingUserProfile = () => {
  return (
    <Layout>
      <UserProfile />
    </Layout>
  );
};
